//
//  SDKExporterCustomBlock.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { ExporterCustomBlockProperty, } from "./SDKExporterCustomBlockProperty";
export var ExporterCustomBlockMode;
(function (ExporterCustomBlockMode) {
    ExporterCustomBlockMode["block"] = "block";
})(ExporterCustomBlockMode || (ExporterCustomBlockMode = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ExporterCustomBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        this.key = model.key;
        this.title = model.title;
        this.description = model.description;
        this.category = model.category;
        this.iconUrl = (_a = model.iconURL) !== null && _a !== void 0 ? _a : null;
        this.mode = model.mode;
        this.properties = model.properties.map((p) => new ExporterCustomBlockProperty(p));
    }
}
